var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExlamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "concept",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo3",
    transform: "translate(-168.000000, -120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(68.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(100.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,-2.02906125e-15 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 1.3527075e-15,31.045695 0,20 C-1.3527075e-15,8.954305 8.954305,2.02906125e-15 20,0 Z",
    id: "back-btn",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.85,21.9166667 L21.2833333,17.5 L21.2833333,14.1666667 L18.7,14.1666667 L18.7,17.5 L19.15,21.9166667 L20.85,21.9166667 Z M20,26.05 C20.3888889,26.05 20.7222222,25.9111111 21,25.6333333 C21.2777778,25.3555556 21.4166667,25.0222222 21.4166667,24.6333333 C21.4166667,24.2444444 21.2777778,23.9111111 21,23.6333333 C20.7222222,23.3555556 20.3888889,23.2166667 20,23.2166667 C19.6111111,23.2166667 19.2777778,23.3555556 19,23.6333333 C18.7222222,23.9111111 18.5833333,24.2444444 18.5833333,24.6333333 C18.5833333,25.0222222 18.7222222,25.3555556 19,25.6333333 C19.2777778,25.9111111 19.6111111,26.05 20,26.05 Z",
    id: "!",
    fill: "#E1E2E3",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExlamationIcon);
export default __webpack_public_path__ + "static/media/exсlamation-icon.2d4bb661.svg";
export { ForwardRef as ReactComponent };